import { defineComponent as c, computed as s, createElementBlock as n, openBlock as i, createVNode as p, Transition as d, withCtx as m, createCommentVNode as u, mergeProps as f, renderSlot as b } from "vue";
import { tw as e } from "../../utils/tailwind.js";
const v = { "aria-live": "polite" }, h = /* @__PURE__ */ c({
  name: "RevStickyBar",
  inheritAttrs: !1,
  __name: "StickyBar",
  props: {
    position: { default: "bottom" },
    visible: { type: Boolean, default: !0 },
    snapToViewPort: { type: Boolean, default: !0 }
  },
  setup(o) {
    const t = o, l = s(() => [
      e`bg-surface-default-low border-static-default-low inset-x-0 z-10 border-solid px-24`,
      {
        top: e`safari-mobile-26:pt-0 top-0 border-b pb-12 pt-[calc(0.75rem+env(safe-area-inset-top))]`,
        bottom: e`safari-mobile-26:pb-0 bottom-0 border-t pb-[calc(0.75rem+env(safe-area-inset-bottom))] pt-12`
      }[t.position],
      t.snapToViewPort && e`fixed`
    ]), a = s(() => ({
      top: e`-translate-y-full`,
      bottom: e`translate-y-full`
    })[t.position]);
    return (r, y) => (i(), n("div", v, [
      p(d, {
        "enter-active-class": "transition duration-300 ease-in motion-reduce:transition-none",
        "enter-from-class": a.value,
        "enter-to-class": "translate-y-0",
        "leave-active-class": "transition duration-300 ease-out motion-reduce:transition-none",
        "leave-to-class": a.value
      }, {
        default: m(() => [
          o.visible ? (i(), n("div", f({ key: 0 }, r.$attrs, { class: l.value }), [
            b(r.$slots, "default")
          ], 16)) : u("", !0)
        ]),
        _: 3
      }, 8, ["enter-from-class", "leave-to-class"])
    ]));
  }
});
export {
  h as default
};
